import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

const GRAYSCALE_STORAGE_KEY = 'napsGrayscaleMode';
const GRAYSCALE_CLASS = 'grayscale-mode';

@Injectable({
  providedIn: 'root'
})
export class GrayscaleService {
  private enabled = false;

  constructor(private storageService: StorageService) {}

  init(): void {
    this.enabled = this.storageService.getData(GRAYSCALE_STORAGE_KEY) === 'true';
    this.applyToDocument();
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  toggle(): void {
    this.enabled = !this.enabled;
    this.storageService.setData(GRAYSCALE_STORAGE_KEY, String(this.enabled));
    this.applyToDocument();
  }

  private applyToDocument(): void {
    document.body.classList.toggle(GRAYSCALE_CLASS, this.enabled);
  }
}
